<template>
  <div class="LBandSourceList" v-loading="loading">
    <div class="LBandSourceWrap" v-scroll="bindLBandScroll" >
      <div class="LBandAdd" @click="CrateEditLBand">
        <i class="iconfont icon-add" :disabled="CloneDisabled.disableButton"></i>
      </div>
      <div class="LBandScrollInner">
        <li
          class="customItemLi"
          v-for="(item, index) in LBandList"
          :key="index"
        >
          <div class="name">
            {{ item.name }}
          </div>
          <div class="backgroundWrap">
            <div class="HoldUp"></div>
            <div
              class="backgroundBox"
              ref="backIframBox"
              v-if="/.*(\.png|\.jpg|\.jpeg|\.gif|\.PNG|\.JPG|\.JPEG|\.GIF)$/g.test(item.url)"
              :style="`backgroundImage:url(${item.url})`"
            ></div>
            <div  class="backgroundBox" ref="backIframBox" v-else >
              <iframe
                :src="`${item.url}`"
                frameborder="0"
                :style="`transform: scale(${zoom})`"
                class="lbandIframe"
              ></iframe>
            </div>
            <div
              class="pgmBox"
              :style="bgStyle(item)"
            >PGM
            </div>
            <div class="OperateWrap">
              <div class="Copy" @click="DeleteAndCopy('copy', item)" >
                <i class="iconfont icon-log" :disabled="CloneDisabled.disableButton"></i>
              </div>
              <div class="Edit" @click="CrateEditLBand('edit', item)" >
                <i class="iconfont icon-bianji" :disabled="CloneDisabled.disableButton"></i>
              </div>
              <div class="Delete" @click="DeleteAndCopy('delete', item)" >
                <i class="iconfont icon-icon14" :disabled="CloneDisabled.disableButton"></i>
              </div>
            </div>
          </div>
        </li>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      class="cropSpurceDialog"
      :show-close="false"
      fullscreen
      :append-to-body="true"
      center
      :close-on-click-modal="false"
      :close-on-press-escapel="false"
      :modal-append-to-body="false"
      :modal="false"
    >
      <LBandCrop
        @close-Dialog="closeDialog"
        v-if="dialogVisible"
        :lBandInfo="LBandMessage"
      />
    </el-dialog>
  </div>
</template>
<script>
import LBandCrop from './LBandCrop'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import Bus from '@/assets/js/vueBus.js'
import commonRequest from '@/assets/js/common/commonRequest.js'
import { mapState } from 'vuex'
export default {
  name: 'LBandList',
  components: {
    LBandCrop
  },
  data () {
    return {
      // 列表
      LBandList: [],
      loading: false,
      // 单个LBand信息
      LBandMessage: {
      },
      // 创建编辑功能开关
      dialogVisible: false,
      programId: '',
      // 绑定滚动事件
      bindLBandScroll: {
        onScroll: this.getLBandList,
        distance: 10,
        directive: '.LBandScrollInner'
      },
      // 获取参数
      getLBandParam: {
        pageSize: 10,
        pageNum: 1,
        nextPage: false
      },
      // 缩放比例
      zoom: '0.1739',
      // 所选分辨率
      VideoResolution: {
        width: 1920,
        height: 1080
      }
    }
  },
  computed: {
    ...mapState({
      State: (state) => state,
      CloneDisabled: (state) => state.playout.CloneDisabled
    }),
    // 列表样式
    bgStyle () {
      return (item) => {
        let xy = ''
        if (item.squeezeType == 1) {
          xy = 'bottom:0;right:0;'
        } else if (item.squeezeType == 3) {
          xy = 'bottom:0;left:0;'
        } else if (item.squeezeType == 0) {
          xy = 'top:0;right:0;'
        } else {
          xy = 'top:0;left:0;'
        }
        const widthRatio = item.width / this.VideoResolution.width * 100
        const heightRatio = item.height / this.VideoResolution.height * 100
        return `width: ${widthRatio}%;height: ${heightRatio}%;${xy}`
      }
    }
  },
  created () {
    this.programId = this.$BehaviorSyns.getProgramId()
    window.addEventListener('resize', this.MonitorResize)
    this.loading = true
    // 获取所选分辨率
    commonRequest.getVideoResolution().then((res) => {
      this.getLBandList(true)
      if (res.width) {
        this.VideoResolution = {
          width: res.width,
          height: res.height
        }
      }
    })
  },
  methods: {
    // 监听页面变化
    MonitorResize () {
      Bus.$emit('resize')
      this.$nextTick(() => {
        if (this.$refs.backIframBox) {
          const width = this.$refs.backIframBox[0].offsetWidth
          this.zoom = width / 1920
        }
      })
    },
    // 获取LBand列表
    getLBandList (type) {
      if (type) {
        this.getLBandParam.pageNum = 1
      } else if (this.getLBandParam.nextPage) {
        this.getLBandParam.pageNum++
      } else {
        return
      }
      const param = {
        programId: this.programId,
        ...this.getLBandParam
      }
      this.loading = true
      this.axios
        .post(Outil.getUrl('/L-Band/pageLBand'), param)
        .then(res => {
          this.loading = false
          if (res.data.errorCode == '0x0') {
            this.getLBandParam.nextPage = res.data.result.hasNextPage
            const list = res.data.result.list
            if (this.getLBandParam.pageNum == 1) {
              this.LBandList = list
            } else {
              this.LBandList.push(...list)
            }
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 创建编辑LBand
    CrateEditLBand (type, item) {
      if (this.CloneDisabled.disableButton) return
      let LBandMessage = {}
      if (type == 'edit') {
        LBandMessage = JSON.parse(JSON.stringify(item))
      }
      this.LBandMessage = LBandMessage
      this.dialogVisible = true
    },
    // 删除复制Lband
    DeleteAndCopy (type, item) {
      if (this.CloneDisabled.disableButton) return
      let url = '/L-Band/duplicateLBand'
      if (type == 'delete') {
        url = '/L-Band/deleteLBandById'
      }
      this.loading = true
      this.axios
        .post(Outil.getUrl(url), {
          id: item.id
        })
        .then(res => {
          if (res.data.errorCode == '0x0') {
            this.getLBandList(true)
          } else {
            this.loading = false
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 关闭编辑弹框
    closeDialog (done) {
      if (done.page == 'save') {
        this.getLBandList(true)
      }
      this.dialogVisible = done.close
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.MonitorResize)
  }
}
</script>
<style lang="less" scoped>
.LBandSourceList {
  width: 100%;
  height: 450px;
  position: relative;
  .LBandSourceWrap{
    min-width: 192px;
    max-width: 336px;
    margin: 0px auto;
    cursor: pointer;
    .LBandAdd{
      width: 100%;
      height: 32px;
      background: #444444;
      border: 1px dashed #666666;
      border-radius: 4px;
      line-height: 32px;
      margin: 10px 0;
      .icon-add{
        font-size: 15px;
        color: #666666;
      }
    }
    .LBandScrollInner {
      height: 390px;
      overflow: auto;
    }
    .customItemLi {
      margin-bottom: 20px;
      .name {
        text-align: left;
        font-size: 14px;
        line-height: 25px;
        color: #DBDBDB;
      }
      .backgroundWrap {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin-right: 24px;
        .HoldUp{
          margin-top: 56.25%;
        }
        .backgroundBox {
          position:absolute;
          left:0;
          right:0;
          top:0;
          bottom: 0;
          background-repeat: no-repeat !important;
          background-size: contain;
          background-position-x: center;
          background-position-y: center;
          .lbandIframe{
            width: 1920px;
            height: 1080px;
            transform-origin: 0 0;
            transform: scale(0.1739);
          }
        }
        .pgmBox {
          position: absolute;
          background: #181a1c;
          color: #f6445a;
          font-size: 1em;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .OperateWrap {
          position: absolute;
          top: 0px;
          right: 0px;
          display: flex;
          display: none;
          div {
            width: 24px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            i {
              color: #ffffff;
              font-size: 12px;;
            }
          }
          .Copy,.Edit {
            background: #252525;
          }
          .Delete{
            background: #EC5050;
          }
        }
        &:hover .OperateWrap{
          display: flex;
        }
      }
    }
  }
}
</style>
<style lang="less">
.GlobalStyle .cropSpurceDialog {
  .el-dialog {
    background: #111213;
    padding: 0px;

    .el-dialog__header {
      padding: 0;
      height: 0;
    }

    .el-dialog__body {
      padding: 0;
      height: 100%;
    }
  }
}
</style>
